import { SecLoansApplicants } from '@shared/sec-loans'
import { ColoredLabel } from '@ui-components/dataDisplay/ColoredLabel'
import { ReactNode } from 'react'
import { useIntl } from 'react-intl'

import { getApplicantColoredLabel } from '../../utils/helpers'

export interface ApplicantStickerProps {
  applicant: SecLoansApplicants
  hasCoApplicant: boolean
}

export const ApplicantSticker = ({ hasCoApplicant, applicant }: ApplicantStickerProps): ReactNode => {
  const labelProps = getApplicantColoredLabel(hasCoApplicant, applicant, useIntl().formatMessage)
  return labelProps && <ColoredLabel color={labelProps.color} text={labelProps.text} />
}
